import {
  dataMap,
  unitMap,
  indexMap,
  assemblyMap,
  assemblyMapUnit,
  costParameterMap,
  costParameterUnitMap,
  unitGeneratorMap,
  generatorUnitMap,
  unitConverterMap,
  unitConverterUnitMap,
  unitCableMap,
  unitCableUnitMap,
  unitBladeMap,
  unitBladeMapUnit
} from './dataMap';

// 机组信息表格数据
export const filterTableData = function(data, type) {
  let dataArr = [];
  // let vendor = data['vendor'] === 0 ? '东方电气' : '其他厂商';
  let newData = [];
  switch (type) {
    case 1:
      for (let key in data) {
        let name = dataMap[key];
        let unit = unitMap[key];
        let serial = indexMap[key];
        let value = data[key];
        let id;
        // if (key === 'turbineType') {
        //   value = data[key] === 1 ? '直驱' : '双馈';
        // }
        if (key === 'state') {
          value = data[key] === 1 ? '是' : '否';
        }
        if (key === 'vendor') {
          value = data[key] === 0 ? '东方电气' : '其他厂商';
        }
        if (key === 'hubHeight') {
          id = data['turbineTypeId'];
          if (name) {
            dataArr.push({
              quota: name,
              value,
              unit: unit,
              id,
              serial: serial
            });
          }
        } else {
          if (name) {
            dataArr.push({ quota: name, value, unit, serial: serial });
          }
        }
      }
      for (let i = 0; i < dataArr.length; i++) {
        newData.push(dataArr[i]);
      }
      newData.forEach((item, index) => {
        if (item.serial === '1.1') {
          dataArr.unshift({ quota: '机组整体数据', serial: '1' });
          // item.value = vendor + '/' + item.value;
        }
        if (index === 42) {
          dataArr.splice(index + 4, 0, {
            quota: '功率因数调节范围或采用定、变浆矩风电机组的功率因数',
            serial: '4.10',
            value: '',
            unit: ''
          });
        }
        // item.value = vendor + '/' + item.value;
        switch (item.serial) {
          case '2.1':
            dataArr.splice(index + 1, 0, { quota: '叶片', serial: '2' });
            break;
          case '3.1':
            dataArr.splice(index + 2, 0, { quota: '齿轮箱', serial: '3' });
            break;
          case '4.1':
            dataArr.splice(index + 3, 0, { quota: '发电机', serial: '4' });
            break;
          case '5.1':
            dataArr.splice(index + 5, 0, { quota: '变流器', serial: '5' });
            break;
          case '6.1':
            dataArr.splice(index + 6, 0, { quota: '补偿电容', serial: '6' });
            break;
          case '7.1':
            dataArr.splice(index + 7, 0, {
              quota: '主轴及主轴承',
              serial: '7'
            });
            break;
          case '8.1':
            dataArr.splice(index + 8, 0, { quota: '制动系统', serial: '8' });
            break;
          case '9.1':
            dataArr.splice(index + 9, 0, { quota: '变桨系统', serial: '9' });
            break;
          case '10.1':
            dataArr.splice(index + 10, 0, { quota: '偏航系统', serial: '10' });
            break;
          case '11.1':
            dataArr.splice(index + 11, 0, { quota: '液压装置', serial: '11' });
            break;
          case '12.1':
            dataArr.splice(index + 12, 0, { quota: '主控系统', serial: '12' });
            break;
          case '13.1':
            dataArr.splice(index + 13, 0, { quota: '监控系统', serial: '13' });
            break;
          case '14.1':
            dataArr.splice(index + 14, 0, {
              quota: '涉网技术性能（标准及性能指标）',
              serial: '14'
            });
            break;
          case '15.1':
            dataArr.splice(index + 15, 0, {
              quota: '附属系统与装置（厂家/型号）',
              serial: '15'
            });
            break;
          case '16.1':
            dataArr.splice(index + 16, 0, { quota: '防雷保护', serial: '16' });
            break;
          case '17.1':
            dataArr.splice(index + 17, 0, {
              quota: '机舱内维修用起重机',
              serial: '17'
            });
            break;
          case '18.1':
            dataArr.splice(index + 18, 0, {
              quota: '机舱（包括机舱罩、底架、导流罩等）',
              serial: '18'
            });
            break;
          case '19.1':
            dataArr.splice(index + 19, 0, { quota: '塔筒', serial: '19' });
            break;
          case '20.1':
            dataArr.splice(index + 20, 0, { quota: '重量', serial: '20' });
            break;
        }
      });
      return dataArr;
    case 2:
      for (let key in data) {
        let name = costParameterMap[key];
        let unit;
        unit = costParameterUnitMap[key] ? costParameterUnitMap[key] : '元';
        let value = data[key];
        if (name) dataArr.push({ quota: name, value, unit: unit });
      }
      return dataArr;
    case 3:
      for (let key in assemblyMap) {
        let map = {
          generatorAssembly: '发电机装配',
          engineRoom: '机舱装配',
          hub: '轮毂装配',
          bladeSingle: '叶片（单支）',
          bladeThree: '叶片（三支）'
        };
        let name = assemblyMap[key];
        let unit = assemblyMapUnit[key];
        let value = data[key];
        let names = '';
        let obj = {
          quota: name,
          value: value,
          unit
        };
        switch (key) {
          case 'generatorAssemblyWeight':
            names = map['generatorAssembly'];
            obj.quotas = names;
            obj.number = 1;
            break;
          case 'engineRoomWeight':
            names = map['engineRoom'];
            obj.quotas = names;
            obj.number = 2;
            break;
          case 'hubWeight':
            names = map['hub'];
            obj.quotas = names;
            obj.number = 3;
            break;
          case 'bladeSingleWeight':
            names = map['bladeSingle'];
            obj.quotas = names;
            obj.number = 4;
            break;
          case 'bladeThreeWeight':
            names = map['bladeThree'];
            obj.quotas = names;
            obj.number = 5;
            break;
        }

        dataArr.push(obj);

        // if (Object.keys(assemblyMap).indexOf(key) !== -1) {
        //   let name = assemblyMap[key];
        //   let value = data[key];
        //   let keyLength = key.replace('Weight', 'Length');
        //   let keyWide = key.replace('Weight', 'Wide');
        //   let keyHigh = key.replace('Weight', 'High');
        //   let size = {
        //     length: data[keyLength],
        //     wide: data[keyWide],
        //     high: data[keyHigh],
        //     bladeMaxChordLength: data['bladeMaxChordLength'],
        //     bladeCylinderDiameter: data['bladeCylinderDiameter'],
        //     bladeTipPrebending: data['bladeTipPrebending']
        //   };
        //   if (name) dataArr.push({ quota: name, value: value, size });
        // }
      }
      return dataArr;
    case 4:
      data.forEach(item => {
        dataArr.push(item);
      });
      return dataArr;
  }
};

// 表格对比1
export const filterCompareTable = function(data, type, modelList) {
  const list = [];
  let [...newData] = data;
  let compareData = [];
  // let vendor = data[0].vendor === 0 ? '东方电气' : '其他厂商';
  switch (type) {
    case 1:
      newData.forEach((item, i) => {
        // item.turbineType = `${item.vendor === 0 ? '东方电气' : '其他厂商'} + ${item.turbineType}`;
        for (let key in newData[i]) {
          if (
            key === 'stateApp' ||
            key === 'statePc' ||
            key === 'display' ||
            key === 'auxiliaryCapacity' ||
            key === 'turbineType' ||
            key === 'vendor' ||
            key === 'startUpTemp'
          ) {
            delete newData[i][key];
          }
        }
      });
      for (let key in newData[0]) {
        let name = dataMap[key];
        let unit = unitMap[key];
        let serial = indexMap[key];
        let row = { quota: name, unit, serial };
        data.forEach(value => {
          modelList.forEach((eco, index) => {
            if (value.turbineTypeId === eco.id) {
              row[`value${index === 0 ? '' : index}`] = value[key];
            }
          });
          // row[`value${index === 0 ? '' : index}`] = value[key];
        });
        if (key !== 'turbineTypeId') {
          list.push(row);
        }
      }
      for (let i = 0; i < list.length; i++) {
        compareData.push(list[i]);
      }
      compareData.forEach((item, index) => {
        if (item.serial === '1.1') {
          list.unshift({ quota: '机组整体数据', serial: '1' });
          // item.value = item.turbineType;
        }
        if (index === 42) {
          let obj = {
            quota: '功率因数调节范围或采用定、变浆矩风电机组的功率因数',
            serial: '4.10',
            unit: ''
          };
          newData.forEach((value, index) => {
            obj[`value${index === 0 ? '' : index}`] = value.ki;
          });
          list.splice(index + 4, 0, obj);
        }
        switch (item.serial) {
          case '2.1':
            list.splice(index + 1, 0, { quota: '叶片', serial: '2' });
            break;
          case '3.1':
            list.splice(index + 2, 0, { quota: '齿轮箱', serial: '3' });
            break;
          case '4.1':
            list.splice(index + 3, 0, { quota: '发电机', serial: '4' });
            break;
          case '5.1':
            list.splice(index + 5, 0, { quota: '变流器', serial: '5' });
            break;
          case '6.1':
            list.splice(index + 6, 0, { quota: '补偿电容', serial: '6' });
            break;
          case '7.1':
            list.splice(index + 7, 0, {
              quota: '主轴及主轴承',
              serial: '7'
            });
            break;
          case '8.1':
            list.splice(index + 8, 0, { quota: '制动系统', serial: '8' });
            break;
          case '9.1':
            list.splice(index + 9, 0, { quota: '变桨系统', serial: '9' });
            break;
          case '10.1':
            list.splice(index + 10, 0, { quota: '偏航系统', serial: '10' });
            break;
          case '11.1':
            list.splice(index + 11, 0, { quota: '液压装置', serial: '11' });
            break;
          case '12.1':
            list.splice(index + 12, 0, { quota: '主控系统', serial: '12' });
            break;
          case '13.1':
            list.splice(index + 13, 0, { quota: '监控系统', serial: '13' });
            break;
          case '14.1':
            list.splice(index + 14, 0, {
              quota: '涉网技术性能（标准及性能指标）',
              serial: '14'
            });
            break;
          case '15.1':
            list.splice(index + 15, 0, {
              quota: '附属系统与装置（厂家/型号）',
              serial: '15'
            });
            break;
          case '16.1':
            list.splice(index + 16, 0, { quota: '防雷保护', serial: '16' });
            break;
          case '17.1':
            list.splice(index + 17, 0, {
              quota: '机舱内维修用起重机',
              serial: '17'
            });
            break;
          case '18.1':
            list.splice(index + 18, 0, {
              quota: '机舱（包括机舱罩、底架、导流罩等）',
              serial: '18'
            });
            break;
          case '19.1':
            list.splice(index + 19, 0, { quota: '塔筒', serial: '19' });
            break;
          case '20.1':
            list.splice(index + 20, 0, { quota: '重量', serial: '20' });
            break;
        }
      });
      break;
    case 2:
      for (let key in costParameterMap) {
        let name = costParameterMap[key];
        let unit = costParameterUnitMap[key] ? costParameterUnitMap[key] : '元';
        let row = { quota: name, unit };
        data.forEach(value => {
          modelList.forEach((eco, index) => {
            if (value.turbineTypeId === eco.id) {
              row[`value${index === 0 ? '' : index}`] = value[key];
            }
          });
          // row[`value${index === 0 ? '' : index}`] = value[key];
        });
        list.push(row);
      }
      break;
    case 3:
      for (let key in assemblyMap) {
        let map = {
          generatorAssembly: '发电机装配',
          engineRoom: '机舱装配',
          hub: '轮毂装配',
          bladeSingle: '叶片（单支）',
          bladeThree: '叶片（三支）'
        };
        let name = assemblyMap[key];
        let unit = assemblyMapUnit[key];
        let names = '';
        let obj = {
          quota: name,
          value: '',
          unit
        };
        data.forEach(value => {
          modelList.forEach((eco, index) => {
            if (value.turbineTypeId === eco.id) {
              obj[`value${index === 0 ? '' : index}`] = value[key];
            }
          });
          // obj[`value${index === 0 ? '' : index}`] = value[key];
        });
        switch (key) {
          case 'generatorAssemblyWeight':
            names = map['generatorAssembly'];
            obj.quotas = names;
            obj.number = 1;
            break;
          case 'engineRoomWeight':
            names = map['engineRoom'];
            obj.quotas = names;
            obj.number = 2;
            break;
          case 'hubWeight':
            names = map['hub'];
            obj.quotas = names;
            obj.number = 3;
            break;
          case 'bladeSingleWeight':
            names = map['bladeSingle'];
            obj.quotas = names;
            obj.number = 4;
            break;
          case 'bladeThreeWeight':
            names = map['bladeThree'];
            obj.quotas = names;
            obj.number = 5;
            break;
        }

        // dataArr.push(obj);
        // let name = assemblyMap[key];
        // let row = { quota: name };
        // let keyLength = key.replace('Weight', 'Length');
        // let keyWide = key.replace('Weight', 'Wide');
        // let keyHigh = key.replace('Weight', 'High');
        // data.forEach((value, index) => {
        //   row[`value${index === 0 ? '' : index}`] = value[key];
        //   row[`size${index === 0 ? '' : index}`] = {
        //     length: value[keyLength],
        //     wide: value[keyWide],
        //     high: value[keyHigh],
        //     bladeMaxChordLength: value['bladeMaxChordLength'],
        //     bladeCylinderDiameter: value['bladeCylinderDiameter'],
        //     bladeTipPrebending: value['bladeTipPrebending']
        //   };
        // });
        list.push(obj);
      }
      break;
    case 4:
      data[0].forEach(item => {
        list.push({ loadRate: item.loadRate });
      });
      list.forEach((item, i) => {
        let modelType = {};
        data.forEach(val => {
          modelType = {
            generatorEfficiency: val[i].generatorEfficiency,
            inverterEfficiency: val[i].inverterEfficiency,
            electricalEfficiency: val[i].electricalEfficiency
          };
          modelList.forEach((eco, index) => {
            if (val[i].turbineTypeId === eco.id) {
              item[`modelType${index === 0 ? '' : index}`] = modelType;
            }
          });
        });
      });
      break;
  }
  return list;
};

// 电气效率
export const filterChartsData = function(data) {
  let dataObj = {
    generatorEfficiency: [],
    inverterEfficiency: [],
    electricalEfficiency: [],
    loadRate: []
  };
  return data.reduce((init, item) => {
    init.generatorEfficiency.push(item.generatorEfficiency);
    init.inverterEfficiency.push(item.inverterEfficiency);
    init.electricalEfficiency.push(item.electricalEfficiency);
    init.loadRate.push(item.loadRate);
    return init;
  }, dataObj);
};
// 获取功率曲线转换
export const filterChangeCurveData = function(data) {
  let dataObj = {
    powerCurve1: [],
    powerCurve2: [],
    conversionPowerCurve: []
  };
  dataObj.powerCurve1 = data.powerCurve1.map(item => {
    return [item.wspd, item.power];
  });
  dataObj.powerCurve2 = data.powerCurve2.map(item => {
    return [item.wspd, item.power];
  });
  dataObj.conversionPowerCurve = data.conversionPowerCurve.map(item => {
    return [item.wspd, item.power];
  });
  return dataObj;
};
// 获取功率-推力-cp曲线图表
export const filterPowerCurveData = function(data) {
  let initObj = { power: [], value: [], thrust: [] };
  return data.reduce((init, item) => {
    init.power.push([item.wspd, item.power]);
    init.value.push([item.wspd, item.value]);
    init.thrust.push([item.wspd, item.thrust]);
    return init;
  }, initObj);
};

// 获取功率曲线多条图表
export const filterPowerCurveMoreData = function(data, type, subtype) {
  if (type === 5) {
    data = data.map(item => {
      return item;
    });
  } else {
    if (type === 9 || type === 10) {
      data = data.map(arr => {
        let obj = {};
        arr = arr.reduce(function(prevArr, currentItem) {
          obj[currentItem.pointId]
            ? ''
            : (obj[currentItem.pointId] = true && prevArr.push(currentItem));
          return prevArr;
        }, []);
        return arr;
      });
    } else {
      data = data.map(arr => {
        let obj = {};
        arr = arr.reduce(function(prevArr, currentItem) {
          obj[currentItem.pointid]
            ? ''
            : (obj[currentItem.pointid] = true && prevArr.push(currentItem));
          return prevArr;
        }, []);
        return arr;
      });
    }
  }
  if (Object.prototype.toString.call(data) === '[object Array]') {
    if (type === 5) {
      data = data.map(arr => {
        if (subtype === '2') {
          return arr.map(item => {
            return [item.wspd, item.thrust];
          });
        } else {
          return arr.map(item => {
            return [item.wspd, item.power];
          });
        }
      });
    }
    if (type === 7) {
      data = data.map(arr => {
        return arr.map(item => {
          return [item.wspd, item.power];
        });
      });
    }
    if (type === 8) {
      data = data.map(arr => {
        return arr.map(item => {
          return [item.wspd, item.power];
        });
      });
    }
    if (type === 9) {
      data = data.map(arr => {
        return arr.map(item => {
          return [item.wspd, item.thrust];
        });
      });
    }
    if (type === 10) {
      data = data.map(arr => {
        return arr.map(item => {
          return [item.ratio, item.value];
        });
      });
    }
  } else {
    let newArr = [];
    for (let key in data) {
      newArr.push(data[key]);
    }
    if (type === 7) {
      data = newArr.map(arr => {
        return arr.map(item => {
          return [item.wspd, item.power];
        });
      });
    }
    if (type === 8) {
      data = newArr.map(arr => {
        return arr.map(item => {
          return [item.wspd, item.power];
        });
      });
    }
    if (type === 9) {
      data = newArr.map(arr => {
        return arr.map(item => {
          return [item.wspd, item.thrust];
        });
      });
    }
    if (type === 10) {
      data = newArr.map(arr => {
        return arr.map(item => {
          return [item.ratio, item.value];
        });
      });
    }
  }
  return data;
};
// 处理功率曲线转换的表格
export const filterChangeTableData = function(data) {
  let newData = data['powerCurve1'].map(item => {
    return {
      power: item.power,
      wspd: item.wspd
    };
  });
  for (let key in data) {
    if (key === 'powerCurve2' && data['powerCurve2'].length > 1) {
      newData.forEach((item, i) => {
        item.power1 = data['powerCurve2'][i].power;
      });
    }
    if (
      key === 'conversionPowerCurve' &&
      data['conversionPowerCurve'].length > 1
    ) {
      newData.forEach((item, index) => {
        item.power2 = data['conversionPowerCurve'][index].power;
      });
    }
  }
  return newData;
};
// 处理多条功率曲线的表格
export const filterCurveMoreTableData = function(data, type, subtype) {
  if (!type) {
    data = data.map(item => {
      return item;
    });
  } else {
    if (type === 9 || type === 10) {
      data = data.map(arr => {
        let obj = {};
        arr = arr.reduce(function(prevArr, currentItem) {
          obj[currentItem.pointId]
            ? ''
            : (obj[currentItem.pointId] = true && prevArr.push(currentItem));
          return prevArr;
        }, []);
        if (type !== 10) {
          let wspdObj = {};
          arr = arr.reduce(function(prevArr, currentItem) {
            wspdObj[currentItem.wspd]
              ? ''
              : (wspdObj[currentItem.wspd] = true && prevArr.push(currentItem));
            return prevArr;
          }, []);
        }
        return arr;
      });
    } else {
      data = data.map(arr => {
        let obj = {};
        arr = arr.reduce(function(prevArr, currentItem) {
          obj[currentItem.pointid]
            ? ''
            : (obj[currentItem.pointid] = true && prevArr.push(currentItem));
          return prevArr;
        }, []);
        let wspdObj = {};
        arr = arr.reduce(function(prevArr, currentItem) {
          wspdObj[currentItem.wspd]
            ? ''
            : (wspdObj[currentItem.wspd] = true && prevArr.push(currentItem));
          return prevArr;
        }, []);
        return arr;
      });
    }
  }
  let tableData = [];
  if (type === 10) {
    data[0].forEach(item => {
      let row = {};
      row.ratio = item.ratio;
      tableData.push(row);
    });
    data.forEach((arr, i) => {
      tableData.forEach((value, index) => {
        value[`power${i === 0 ? '' : i}`] = arr[index].value;
      });
    });
  } else {
    let wspd = [];
    for (let i = 0; i < data.length; i++) {
      data[i].forEach(value => {
        wspd.push(value.wspd);
      });
    }
    wspd.sort(function(a, b) {
      return a - b;
    });
    wspd = wspd.filter(function(item, index, arr) {
      return arr.indexOf(item, 0) === index;
    });
    //   let newData = data.reduce(function(a, b) {
    //     return a.concat(b);
    //   });
    //   for (let i = 0; i < wspd.length; i++) {
    //     let power;
    //     let obj = {};
    //     let temp = 0;
    //     newData.forEach(item => {
    //       if (item.wspd === wspd[i]) {
    //         power = 'power' + `${temp === 0 ? '' : temp}`;
    //         temp = temp + 1;
    //         if (temp <= 1) {
    //           obj.wspd = wspd[i];
    //           if (!type) {
    //             if (subtype === '2') {
    //               obj[power] = item.thrust;
    //             } else {
    //               obj[power] = item.power;
    //             }
    //           } else {
    //             if (type === 9) {
    //               obj[power] = item.thrust;
    //             } else if (type === 10) {
    //               obj[power] = item.value;
    //             } else {
    //               obj[power] = item.power;
    //             }
    //           }
    //           tableData.push(obj);
    //         } else {
    //           tableData.forEach(value => {
    //             if (value.wspd === wspd[i]) {
    //               value.wspd = wspd[i];
    //               if (!type) {
    //                 if (subtype === '2') {
    //                   value[power] = item.thrust;
    //                 } else {
    //                   value[power] = item.power;
    //                 }
    //               } else {
    //                 if (type === 9) {
    //                   value[power] = item.thrust;
    //                 } else if (type === 10) {
    //                   value[power] = item.value;
    //                 } else {
    //                   value[power] = item.power;
    //                 }
    //               }
    //             }
    //           });
    //         }
    //       }
    //     });
    //   }
    // let newData = data.reduce(function(a, b) {
    //   return a.concat(b);
    // });
    for (let i = 0; i < wspd.length; i++) {
      let power;
      let obj = {};
      // let temp = 0;
      data.forEach((arr, temp) => {
        arr.forEach(item => {
          if (item.wspd === wspd[i]) {
            power = 'power' + `${temp === 0 ? '' : temp}`;
            temp = temp + 1;
            // 不同机型不同的值
            // modelList.forEach((eco, index) => {
            //   if (arr[temp].turbineTypeId === eco.id) {
            //     power = 'power' + `${index === 0 ? '' : index}`;
            //   }
            // });
            if (temp <= 1) {
              obj.wspd = wspd[i];
              if (!type) {
                if (subtype === '2') {
                  obj[power] = item.thrust;
                } else {
                  obj[power] = item.power;
                }
              } else {
                if (type === 9) {
                  obj[power] = item.thrust;
                } else if (type === 10) {
                  obj[power] = item.value;
                } else {
                  obj[power] = item.power;
                }
              }
              if (
                !tableData.some(item => {
                  return item.wspd === wspd[i];
                })
              ) {
                tableData.push(obj);
              }
            } else {
              tableData.forEach(value => {
                if (value.wspd === wspd[i]) {
                  value.wspd = wspd[i];
                  if (!type) {
                    if (subtype === '2') {
                      value[power] = item.thrust;
                    } else {
                      value[power] = item.power;
                    }
                  } else {
                    if (type === 9) {
                      value[power] = item.thrust;
                    } else if (type === 10) {
                      value[power] = item.value;
                    } else {
                      value[power] = item.power;
                    }
                  }
                }
              });
            }
          }
        });
      });
    }
  }
  return tableData;
};

// 部件详情处理方法
export const filterUnitTableData = function(data, type) {
  // 部件塔筒index
  let indexs = 0;
  let newIndex = 0;
  let topTube = {
    towerMaterialSpecification: '塔筒材料规格',
    basicInterfaceType: '基础接口形式',
    hubHeight: '轮毂高度'
  };
  let topTubeUnit = {
    towerMaterialSpecification: '--',
    basicInterfaceType: '--',
    hubHeight: 'm'
  };
  let tubeDetail = {
    length: '长度',
    heartHeight: '重心高度',
    weight: '重量',
    upperFlange: '上法兰外径',
    downFlange: '下法兰外径'
  };
  let tubeDetailUnit = {
    length: 'm',
    heartHeight: 'm',
    weight: 'kg',
    upperFlange: 'm',
    downFlange: 'm'
  };
  if (type === 5) {
    let newData = [];
    let keyArr = Object.keys(data);
    keyArr.forEach(item => {
      if (item === 'lblade' || item === 'bpower') {
        newData.splice(3, 0, 'lblade');
        newData.splice(4, 0, 'bpower');
      } else if (item === 'droot') {
        newData.splice(14, 0, 'droot');
      } else if (item === 'nplySc') {
        newData.splice(20, 0, 'nplySc');
      } else if (item === 'type') {
        newData.unshift('type');
      } else if (item === 'name') {
        newData.unshift('name');
      } else {
        newData.push(item);
      }
    });
    let dataObj = {};
    newData.forEach(item => {
      dataObj[item] = data[item];
    });
    data = dataObj;
  }
  let dataArr = [];
  switch (type) {
    case 1:
      for (let key in unitGeneratorMap) {
        let obj = {
          quota: unitGeneratorMap[key],
          unit: generatorUnitMap[key],
          value: data[key]
        };
        dataArr.push(obj);
      }
      break;
    case 2:
      for (let key in unitConverterMap) {
        let obj = {
          quota: unitConverterMap[key],
          unit: unitConverterUnitMap[key],
          value: data[key]
        };
        dataArr.push(obj);
      }
      break;
    case 3:
      for (let key in unitCableMap) {
        let map = {
          machineSidePowerCable: '机侧动力电缆根数',
          meshSideEarthingCable: '网侧动力电缆根数',
          meshSidePowerCable: '网侧接地电缆根数'
        };
        let obj = {};
        if (key !== 'busType') {
          obj.name = unitCableMap[key];
          obj.unit = unitCableUnitMap[key];
          obj.value = data[key];
        } else {
          obj.names = unitCableMap[key];
          obj.unit = unitCableUnitMap[key];
          obj.number = 4;
          obj.value = data['busType'];
        }
        switch (key) {
          case 'machineSidePowerCableNumber':
            obj.names = map['machineSidePowerCable'];
            obj.number = 1;
            break;
          case 'meshSideEarthingCableNumber':
            obj.names = map['meshSideEarthingCable'];
            obj.number = 2;
            break;
          case 'meshSidePowerCableNumber':
            obj.names = map['meshSidePowerCable'];
            obj.number = 3;
            break;
        }
        dataArr.push(obj);
      }
      // dataArr.unshift({ names: '线缆名称', unit: '', value: '', number: 1 });
      break;
    case 4:
      for (let key in topTube) {
        indexs++;
        let tubeName = topTube[key];
        let unit = topTubeUnit[key];
        let row = { tubeName, unit, number: indexs };
        if (key === 'hubHeight') {
          row.name = 'm';
        }
        row[`value`] = data.tube[key];
        dataArr.push(row);
      }

      for (let i = 0; i < 10; i++) {
        newIndex = i + 1 + indexs;
        for (let key in tubeDetail) {
          let rowDetail = {};
          let name = tubeDetail[key];
          let unit = tubeDetailUnit[key];
          rowDetail = { name, unit, number: newIndex };
          if (key === 'length') {
            rowDetail.tubeName = `塔筒${i + 1}段`;
          }
          if (data.tubeDetail[i]) {
            rowDetail[`value`] = data.tubeDetail[i][key];
          }
          dataArr.push(rowDetail);
        }
      }

      dataArr.push({
        tubeName: '附件',
        unit: 'kg',
        name: 'kg',
        value: data.tube['weightAccessories'],
        number: newIndex + 1
      });
      dataArr.push({
        tubeName: '总计',
        unit: 'm',
        name: '长度',
        value: data.tube['lengthTotal'],
        number: newIndex + 2
      });
      dataArr.push({
        tubeName: '总计',
        unit: 'kg',
        name: '重量',
        value: data.tube['weightTotal'],
        number: newIndex + 3
      });
      break;
    case 5:
      for (let key in unitBladeMap) {
        let obj = {
          quota: unitBladeMap[key],
          unit: unitBladeMapUnit[key],
          value: data[key]
        };
        dataArr.push(obj);
      }
      break;
  }
  return dataArr;
};
// 对比部件详情处理方法
export const filterCompareUnit = function(data, type) {
  let unitList = [];
  // let objs = {
  //   names: '线缆名称',
  //   unit: '',
  //   number: 1
  // };
  switch (type) {
    case 1:
      for (let key in unitGeneratorMap) {
        let name = unitGeneratorMap[key];
        let unit = generatorUnitMap[key];
        let row = { quota: name, unit };
        data.forEach((value, index) => {
          row[`value${index === 0 ? '' : index}`] = value[key];
        });
        unitList.push(row);
      }
      break;
    case 2:
      for (let key in unitConverterMap) {
        let name = unitConverterMap[key];
        let unit = unitConverterUnitMap[key];
        let row = { quota: name, unit };
        data.forEach((value, index) => {
          row[`value${index === 0 ? '' : index}`] = value[key];
        });
        unitList.push(row);
      }
      break;
    case 3:
      for (let key in unitCableMap) {
        let map = {
          machineSidePowerCable: '机侧动力电缆根数',
          meshSideEarthingCable: '网侧动力电缆根数',
          meshSidePowerCable: '网侧接地电缆根数'
        };
        let obj = {};
        if (key !== 'busType') {
          obj.name = unitCableMap[key];
          obj.unit = unitCableUnitMap[key];
          data.forEach((item, index) => {
            obj[`value${index === 0 ? '' : index}`] = item[key];
          });
        } else {
          obj.names = unitCableMap[key];
          obj.unit = unitCableUnitMap[key];
          obj.number = 4;
          data.forEach((item, index) => {
            obj[`value${index === 0 ? '' : index}`] = item['busType'];
          });
        }
        switch (key) {
          case 'machineSidePowerCableNumber':
            obj.names = map['machineSidePowerCable'];
            obj.number = 1;
            break;
          case 'meshSideEarthingCableNumber':
            obj.names = map['meshSideEarthingCable'];
            obj.number = 2;
            break;
          case 'meshSidePowerCableNumber':
            obj.names = map['meshSidePowerCable'];
            obj.number = 3;
            break;
        }
        unitList.push(obj);
      }
      // data.forEach((item, index) => {
      //   objs[`value${index === 0 ? '' : index}`] = '';
      // });
      // unitList.unshift(objs);
      // for (let key in unitCableMaps) {
      //   if (key !== 'busType') {
      //     let name = unitCableMaps[key];
      //     let rootsObj = { name, valuename: '根数（根）' };
      //     data.forEach((item, index) => {
      //       rootsObj[`value${index === 0 ? '' : index}`] = item[key];
      //     });
      //     unitList.push(rootsObj);
      //     let standardObj = { name, valuename: '规格（mm²）' };
      //     let newKey = key.replace('Number', 'Standard');
      //     data.forEach((item, index) => {
      //       standardObj[`value${index === 0 ? '' : index}`] = item[newKey];
      //     });
      //     unitList.push(standardObj);
      //   } else {
      //     let name = unitCableMaps[key];
      //     let bustypeObj = { name };
      //     data.forEach((item, index) => {
      //       bustypeObj[`value${index === 0 ? '' : index}`] = item[key];
      //     });
      //     unitList.push(bustypeObj);
      //   }
      // }
      break;
    case 4:
      break;
    case 5:
      for (let key in unitBladeMap) {
        let name = unitBladeMap[key];
        let unit = unitBladeMapUnit[key];
        let row = { quota: name, unit };
        data.forEach((value, index) => {
          row[`value${index === 0 ? '' : index}`] = value[key];
        });
        unitList.push(row);
      }
      break;
  }
  return unitList;
};
export const filterCompareUnit4 = function(data) {
  let unitList = [];
  // 部件塔筒index
  let indexs = 0;
  let newIndex = 0;
  let weightAccessories = {
    tubeName: '附件',
    unit: 'kg',
    name: 'kg',
    number: newIndex + 1
  };
  let lengthTotal = {
    tubeName: '总计',
    unit: 'm',
    name: '长度',
    number: newIndex + 2
  };
  let weightTotal = {
    tubeName: '总计',
    unit: 'kg',
    name: '重量',
    number: newIndex + 3
  };
  let topTube = {
    towerMaterialSpecification: '塔筒材料规格',
    basicInterfaceType: '基础接口形式',
    hubHeight: '轮毂高度'
  };
  let topTubeUnit = {
    towerMaterialSpecification: '--',
    basicInterfaceType: '--',
    hubHeight: 'm'
  };
  let tubeDetails = {
    length: '长度',
    heartHeight: '重心高度',
    weight: '重量',
    upperFlange: '上法兰外径',
    downFlange: '下法兰外径'
  };
  let tubeDetailUnit = {
    length: 'm',
    heartHeight: 'm',
    weight: 'kg',
    upperFlange: 'm',
    downFlange: 'm'
  };
  for (let key in topTube) {
    indexs++;
    let tubeName = topTube[key];
    let unit = topTubeUnit[key];
    let row = { tubeName, unit, number: indexs };
    if (key === 'hubHeight') {
      row.name = 'm';
    }
    data.forEach((item, index) => {
      row[`value${index === 0 ? '' : index}`] = item.tube[key];
    });
    unitList.push(row);
  }
  for (let i = 0; i < 10; i++) {
    newIndex = i + 1 + indexs;
    for (let key in tubeDetails) {
      let rowDetail = {};
      let name = tubeDetails[key];
      let unit = tubeDetailUnit[key];
      rowDetail = { name, unit, number: newIndex };
      if (key === 'length') {
        rowDetail.tubeName = `塔筒${i + 1}段`;
      }
      data.forEach((val, index) => {
        if (val.tubeDetail[i]) {
          rowDetail[`value${index === 0 ? '' : index}`] =
            val.tubeDetail[i][key];
        }
      });
      unitList.push(rowDetail);
    }
  }
  data.forEach((val, index) => {
    weightAccessories[`value${index === 0 ? '' : index}`] =
      val.tube.weightAccessories;
    lengthTotal[`value${index === 0 ? '' : index}`] = val.tube.lengthTotal;
    weightTotal[`value${index === 0 ? '' : index}`] = val.tube.weightTotal;
  });
  weightAccessories.number = newIndex + 1;
  lengthTotal.number = newIndex + 2;
  weightTotal.number = newIndex + 3;
  unitList.push(weightAccessories);
  unitList.push(lengthTotal);
  unitList.push(weightTotal);
  return unitList;
};
